/**
 * Helper Swal class / preparation to SweetAlert v8+
 * https://sweetalert2.github.io/
 */
export default class Swal {
  static fire({ title, text, ...props}) {
    props.title = title;
    props.text = text;

    return window.swal(Swal.determineProps(props))
  }

  static remove({ title, text, ...props}) {
    props.title = title;
    props.text = text;

    const swalProps = Swal.determineProps(props);
    swalProps.customClass = 'swal--remove' + (swalProps.customClass ? ' ' + swalProps.customClass : '');

    return Swal.fire(swalProps);
  }

  static determineProps(props) {
    const defaultSwalProps = {
      type: 'warning',
      showCloseButton: true,
      showCancelButton: true,
      cancelButtonText: trans('button.cancel'),
      confirmButtonText: trans('button.confirm'),
      confirmButtonClass: 'btn--confirm',
      cancelButtonClass: 'btn--cancel',
    };

    if (!defaultSwalProps.reverseButtons) {
      defaultSwalProps.reverseButtons = window.innerWidth > 575;
    }

    return {...defaultSwalProps, ...props};
  }
}
